import {KeyValueTable, RichText} from '@sdox/ui'

import type {XcNwBlock_BlockKeyValueTableType_Fragment} from '@sdox/api'

export const BlockKeyValueTable = (props: XcNwBlock_BlockKeyValueTableType_Fragment) => {
  return (
    <KeyValueTable
      alignValue={props.alignValue}
      data={props.items.map(kv => ({
        label: (
          <RichText
            content={kv.key}
            allowedTags={['span']}
          />
        ),
        data: (
          <RichText
            content={kv.value}
          />
        ),
      }))}
    />
  )
}
